var site = site || {};

(function ($) {
  Drupal.behaviors.compareImageSliderV1 = {
    $document: $(document),
    $window: $(window),
    $modules: [],
    isRTL: site.direction.isRTL,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-compare-image-slider', context);

      $modules.each(function () {
        var $module = $(this);
        var $images = $module.find('img');
        var imagesToLoad = $images.length;
        var imagesLoaded = 0;

        function initModule() {
          self.getDom($module);
          self.setProps($module);
          self.setInits($module);
          self.setListeners($module);
          self.$modules.push($module);
        }

        function initWhenReady() {
          imagesLoaded++;
          if (imagesLoaded === imagesToLoad) {
            initModule();
          }
        }

        if (imagesToLoad === 0) {
          initModule();
        } else {
          $images.each(function() {
            if (this.complete) {
              initWhenReady();
            } else {
              $(this).one('load', initWhenReady).one('error', initWhenReady);
            }
          });
        }
      });
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.state = {};
      $module.nodes.main = $('.js-compare-image-slider-main', $module);
      $module.nodes.container = $('.js-compare-image-slider-container', $module);
      $module.nodes.modified = $('.js-compare-image-slider-modified', $module);
      $module.nodes.original = $('.js-compare-image-slider-original', $module);
      $module.nodes.dragElement = $('.js-compare-image-slider-handle', $module);
      $module.nodes.dragElementImg = $('.js-compare-image-slider-handleimg', $module);
      $module.nodes.handleScreen = $('.js-compare-image-slider-handle-screen', $module);
      $module.nodes.resizeElement = $('.js-compare-image-slider-resized', $module);
      $module.state.dragging = false;
      $module.state.leave = false;
    },
    setProps: function ($module) {
      $module.props = {};
      $module.props.draggerWidth = $module.nodes.dragElement.outerWidth();
      $module.props.draggerImgWidth = $module.nodes.dragElementImg.outerWidth();
      $module.props.containerOffset = $module.nodes.container.offset().left;
      $module.props.containerWidth = $module.nodes.container.outerWidth();
      $module.props.draggerOffset = $module.nodes.dragElement.offset().left;
      
    },
    setInits: function ($module) {
      var self = this;

      $module.nodes.original.width($module.nodes.modified.outerWidth(true));

      var initialPosition = 50;
      // Half-width of the vertical divider line (centers handle on the border).
      var borderWidthHalf = 1.5;
      var initialWidthValue = self.getRTLPosition(initialPosition);

      $module.nodes.resizeElement.css('width', initialWidthValue + '%');
      $module.nodes.dragElement.css('left', 'calc(' + initialPosition + '% - ' + borderWidthHalf + 'px)');

      if ($module.nodes.handleScreen.length > 0) {
        $module.nodes.handleScreen.height($module.nodes.dragElement.height());
      }
    },
    getRTLPosition: function (position) {
      var self = this;
      var startingPoint = self.isRTL ? 100 : 0;
      var dirMult = self.isRTL ? -1 : 1;

      return startingPoint + position * dirMult;
    },
    setActive: function ($module, active) {
      $module.state.dragging = active;
      if (active) {
        $module.nodes.dragElement.addClass('draggable');
        $module.nodes.resizeElement.addClass('resizable');
      } else {
        $module.nodes.dragElement.removeClass('draggable');
        $module.nodes.resizeElement.removeClass('resizable');
      }
    },
    setListeners: function ($module) {
      var self = this;
      var xPosition;

      $module.nodes.dragElement.on('mousedown vmousedown', function (e) {
        self.setActive($module, true);
        xPosition = $module.nodes.dragElement.offset().left + $module.props.draggerWidth - e.pageX;
        e.preventDefault();
      }).on('mouseup vmouseup', function () {
        self.setActive($module, false);
      });
      $module.nodes.container.on('mousemove vmousemove', function (evt) {
        if ($module.state.dragging) {
          (!window.requestAnimationFrame)
          ? setTimeout(function () {
            self.onDragSlider(evt, xPosition, $module);
          }, 100)
          : requestAnimationFrame(function () {
            self.onDragSlider(evt, xPosition, $module);
          });
        }
      }).on('mouseleave', function () {
        $module.state.leave = true;
      }).on('mouseup', function () {
        self.setActive($module, false);
      }).on('mouseenter', function () {
        $module.state.leave = false;
      });

      self.$window.on('mouseup', function () {
        if ($module.state.leave) {
          self.setActive($module, false);
        }
      });
      
      self.$window.off('resize.compareImageSlider').on('resize.compareImageSlider', _.debounce(function () {
        self.$modules.forEach(function ($mod) {
          self.setProps($mod);
          self.setInits($mod);
        });
      }, 100));
    },

    onDragSlider: function (e, xPosition, $module) {
      var self = this;
      var borderWidthHalf = 1.5;
      var leftValue = e.pageX + xPosition - $module.props.draggerImgWidth;
      var minLeft = $module.props.containerOffset + borderWidthHalf;
      var maxLeft = $module.props.containerOffset + $module.props.containerWidth - $module.props.draggerImgWidth - borderWidthHalf
      var widthValue;
      var widthValueRTL;

      if (leftValue < minLeft) {
        leftValue = minLeft;
      } else if (leftValue > maxLeft) {
        leftValue = maxLeft;
      }

      widthValue = (leftValue + $module.props.draggerImgWidth / 2 - $module.props.containerOffset) * 100 / $module.props.containerWidth + '%';
      $('.draggable', $module).css('left', 'calc(' + widthValue + ' - ' + String(borderWidthHalf) + 'px)').on('mouseup vmouseup', function () {
        $(this).removeClass('draggable');
        $module.nodes.resizeElement.removeClass('resizable');
      });
      widthValueRTL = self.getRTLPosition(parseFloat(widthValue));
      $('.resizable', $module).css('width', widthValueRTL + '%');
    }
  };
})(jQuery);
